import Events from 'pages/events'

export default Events
